module.exports = __webpack_public_path__ + "static/media/media-upload-active.815a831e.svg";